import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state = {
  errors: {}, // for Laravel 422 validation errors
}

const namespaced = true

export const validations = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
